import CourseTypeLoader from './CourseTypeLoader';

export default CourseTypeLoader;
